import { NavigateFunction } from "react-router-dom";

export const handleLeadRedirect = (
  lead: any,
  navigate: NavigateFunction,
) => {
  const status = lead?.status;

  // 🔥 LOGIN / PENDING
  if (status === "login" || status === "pending") {
    navigate(`/leads/view/${lead._id}`);
    return;
  }

  // 🔥 CREDIT
  if (status === "credit") {
    navigate(`/credit/create/${lead._id}`);
    return;
  }

  // 🔥 APPROVED
  if (status === "approved") {
    navigate(`/credit/view/${lead._id}`);
    return;
  }

  // 🔥 DISBURSED
  if (status === "disbursed") {
    navigate(`/disbursement/view/${lead.loanId}`);
    return;
  }

  // 🔥 FALLBACK
  navigate(`/leads/view/${lead._id}`);
};